import React, { Children } from 'react'
import PropTypes from 'prop-types'
import { IconButton, ListItem, ListItemIcon, ListItemText, Skeleton } from '@mui/material'

const ServiceSkeleton = ({ rows = 1 }) => {
  const shimmersArray = new Array(rows).fill()

  return Children.toArray(
    shimmersArray.map((_, index) => (
      <ListItem divider={index !== rows - 1}>
        <ListItemIcon sx={{ minWidth: 'auto' }}>
          <IconButton>
            <Skeleton width="1.5rem" />
          </IconButton>
        </ListItemIcon>
        <ListItemText primary={<Skeleton variant="text" width="15rem" />} secondary={<Skeleton variant="text" width="7rem" />} />
        <ListItemIcon sx={{ mr: 2 }}>
          <Skeleton width="10rem" />
        </ListItemIcon>
      </ListItem>
    ))
  )
}

ServiceSkeleton.propTypes = {
  rows: PropTypes.number,
}

export default ServiceSkeleton
